module.exports = __webpack_public_path__ + "static/media/relativo-img.23ab3438.png";